import { ConfirmationDialog } from 'app/components'
import React, { useState } from 'react'

const RunProject = ({
  runProject,
  setStartRunProject,
  handleRunProject,
  isCompleted,
}) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false)

  const handleCloseConfirmRun = () => {
    setStartRunProject(false)
    setShowConfirmDialog(false)
  }
  const handleConfirmRun = () => {
    setStartRunProject(false)
    setShowConfirmDialog(false)
    handleRunProject()
  }

  React.useEffect(() => {
    if (runProject) {
      if (isCompleted) {
        setShowConfirmDialog(true)
      } else {
        handleRunProject()
        setStartRunProject(false)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [runProject])

  return (
    <>
      {showConfirmDialog && (
        <ConfirmationDialog
          open={runProject}
          onConfirmDialogClose={handleCloseConfirmRun}
          onYesClick={handleConfirmRun}
          text="Are you sure to run the project and delete previous results?"
        />
      )}
    </>
  )
}
export default RunProject
